import { DSButton } from "components/UI/atoms";
import "./index.scss";

export const BrandAlertCanceled = ({
  handleResetAlert,
  handleAddBrandAlert
}) => {
  return (
    <div className="brand-alert-canceled" data-testid="brand-alert-canceled">
      <div className="buttons-area">
        <DSButton variant="outlined" onClick={handleResetAlert}>
          Reset My Cancelled Brand Alert
        </DSButton>
        <DSButton variant="secondary" onClick={handleAddBrandAlert}>
          Add Brand Alert
        </DSButton>
      </div>
    </div>
  );
};
